import React, { ChangeEvent, FC } from "react";

import { MediumText } from "components/MediumText/MediumText";

interface NamedCounterProps {
  title: string;
  value?: number | string;
  symbol?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
  titleClassName?: any;
  titleWidth?: number;
}

export const NamedCounter: FC<NamedCounterProps> = ({
  value,
  symbol,
  title,
  onChange,
  style,
  titleClassName,
  titleWidth,
}) => {
  return (
    <div className="flex items-center">
      {title && (
        <MediumText
          size={12}
          className={titleClassName}
          style={titleWidth ? { width: `${titleWidth}px` } : {}}
        >
          {title}
        </MediumText>
      )}
      <div
        style={{
          position: "relative",
        }}
      >
        <input
          style={{
            width: 80,
            height: 30,
            padding: 5,
            border: "1px solid #E6E6E6",
            borderRadius: 5,
            fontSize: 16,
            paddingRight: 0,
            ...style,
          }}
          placeholder="0"
          type="number"
          value={value}
          onChange={onChange}
          onWheel={(e) => e.currentTarget.blur()}
        />
        {symbol && (
          <span
            style={{
              position: "absolute",
              top: "45%",
              right: "30%",
              transform: "translateY(-50%)",
            }}
          >
            {symbol}
          </span>
        )}
      </div>
    </div>
  );
};
